import { WebPlugin } from '@capacitor/core';
export class CapacitorWifiConnectPluginWeb extends WebPlugin {
    checkPermission() {
        throw new Error('Method not implemented.');
    }
    requestPermission() {
        throw new Error('Method not implemented.');
    }
    disconnect() {
        throw new Error('Method not implemented.');
    }
    getAppSSID() {
        throw new Error('Method not implemented.');
    }
    getDeviceSSID() {
        throw new Error('Method not implemented.');
    }
    getSSIDs() {
        throw new Error('Method not implemented.');
    }
    connect(options) {
        options;
        throw new Error('Method not implemented.');
    }
    prefixConnect(options) {
        options;
        throw new Error('Method not implemented.');
    }
    secureConnect(options) {
        options;
        throw new Error('Method not implemented.');
    }
    securePrefixConnect(options) {
        options;
        throw new Error('Method not implemented.');
    }
}
//# sourceMappingURL=web.js.map